import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50px',
    cursor: 'pointer',
    background: theme.palette.secondary.main,

    '& > div': {
      fontSize: theme.size.base,
      color: theme.palette.primary.main
    },

    '&:hover > div': {
      textDecoration: 'underline'
    }
  }
}))

export default useStyles
